import { IBidder } from "../parcel/IBidder";
import { IParcelBidLog } from "../parcel/IParcelBidLog";
import IAuctionStatus from "../auction/IAuctionStatus";
import { BidLoadState } from "../utility/LoadState";

export default class AuctionsHub {
    public static readonly ReceiveCommands = {
        ReceiveApprovedParcelBid: "ReceiveApprovedParcelBid",
        ReceiveBatchLiveStatus: "ReceiveBatchLiveStatus",
        ReceiveParcelBidLogUpdate: "ReceiveParcelBidLogUpdate",
        ReceiveParcelClocksUpdate: "ReceiveParcelClocksUpdate",
        ReceiveParcelUpdate: "ReceiveParcelUpdate",
        ReceiveApprovedEnBlocBidders: "ReceiveApprovedEnBlocBidders",
        BidProcessingComplete: "BidProcessingComplete"
    };
    public static readonly DebugCommands = {
        ReceiveLatencyTestResults: "ReceiveLatencyTestResults"
    };
}

// receive messages
export interface IApprovedParcelBid {
    bidAmount: number;
    bidReceivedTime: string;
    checkoutToken: string;
    parcelId: string;
    userId: string;
    endTime: string;
}
export interface IAuctionLiveUpdate {
    auctionId: string;
    live: boolean;
    completed: boolean;
}
export interface IParcelBidLogUpdate {
    parcelId: string;
    bidLog: IParcelBidLog;
}
export interface IParcelClocksUpdate {
    nextMessageDueTime: string;
    currentServerTime: string;
    liveParcels: IAuctionStatus[]; // Parcels from live auctions. Note the parcels might not be live.
}
export interface IParcelLiveStatus {
    parcelId: string;
    startDate: string;
    endDate: string;
    isLive: boolean;
    isCompleted: boolean;
}
export interface IBidderUpdate {
    parcelId: string;
    bidders: IBidder[];
}
export interface IBatchLiveUpdate {
    auctions: IAuctionLiveUpdate[];
    parcels: IParcelLiveStatus[];
}
export interface IBidProcessingComplete {
    parcelId: string;
    result: BidLoadState;
    errorText: string;
    checkoutToken: string;
    lastAcceptedBid: number;
}

export interface ILatencyTestResults {
    startTime: string;
    processedTime: string;
}
